<script>

</script>


<div class="divider"></div>

<div id="about_work" class="section">
    <div class="container">  
        <div class="row">            

            <h4 class="blue-grey-text text-lighten-2">About my work</h4>

            <p class="flow-text">My work is inspired by <em>Futurism</em> and late <em>Cubism</em>. I classify my work as (or like to call it) <em class="strong">"Reformist Neo-Cubist"</em>, which consists of abstracting, reducing and decomposing figures to their most essential shapes, and reconstructing them through the use of bold colors and strong compositions, to better represent the dynamism and complexity of their interations with other objects and their surroundings. Over the years, my work has been acquired by many art collectors and exhibited in several galleries in Guadalajara (Mexico), San Francisco, Las Vegas and Dallas (USA), Denmark, Faroe Islands, Italy and South America.</p>
        
            <p class="flow-text">A few years ago, my work was nominated to be included in the permanent collection of the following museums. It was reviewed by their acquisition committees and even though it wasn't selected, it was still a big honor to be considered for their respective collections.</p>
            <ul class="list">
                <li class="collection-item"><span class="strong">NMMA</span>, National Museum of Mexican Art. Chicago IL.</li>
                <li class="collection-item"><span class="strong">MOLAA</span>, Museum of Latin American Art. Long Beach CA.</li>
                <li class="collection-item"><span class="strong">MALBA</span>, Museo de Arte Latinoamericano de Buenos Aires. Buenos Aires, Argentina.</li>
            </ul>  

        </div>
    </div>
</div>



<style>
    .list{ margin-left: 25px; }
    .list li{ list-style-type: square !important;}

    @media screen and (min-width: 400px) {
        .flow-text { font-size: 1.2em; }
    }

</style>